import { BetDateType } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const betDateTypeDictionary = createSimpleDictionary([
    { id: BetDateType.PlacementLondon, name: 'bets.placementLondon' },
    { id: BetDateType.SettlementLondon, name: 'bets.settlementLondon' },
    { id: BetDateType.PlacementGMT, name: 'bets.placementGmt' },
    { id: BetDateType.SettlementGMT, name: 'bets.settlementGmt' },
]);
